<span class="tt-o-badge" :class="typeClass"><slot/></span>


// WEBPACK FOOTER //
// ./src/objects/badge/badge.html